import { ComponentProps, forwardRef } from "react";
import { Link, LinkProps } from "@mui/material";
import NextLink from "next/link";

export interface IHashLinkProps extends LinkProps {
    href: string;
}

export type IHashLinkUnstyledProps = ComponentProps<typeof NextLink>;

// Dev-Note: Use for links that only change the URL hash (e.g. #login, #register); routes through NextLink.

export const HashLink = forwardRef<HTMLAnchorElement, IHashLinkProps>(({ children, href, ...linkProps }, ref) => {
    return (
        <Link component={NextLink} href={href} ref={ref} {...linkProps}>
            {children}
        </Link>
    );
});

HashLink.displayName = "HashLink";

export const HashLinkUnstyled = forwardRef<HTMLAnchorElement, IHashLinkUnstyledProps>(({ children, ...linkProps }, ref) => {
    return (
        <NextLink ref={ref} {...linkProps}>
            {children}
        </NextLink>
    );
});

HashLinkUnstyled.displayName = "HashLinkUnstyled";
